(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aa-bundle-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    class AaBundleSelector extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bundleInit === 'true') return;
        this.dataset.bundleInit = 'true';

        this.boundHandleCardClick = this.handleCardClick.bind(this);
        this.boundHandleProductSelect = this.handleProductSelect.bind(this);

        this.addEventListener('click', this.boundHandleCardClick);

        this.scopeElement = this.closest('.shopify-section, dialog');
        if (this.scopeElement) {
          this.scopeElement.addEventListener('shopify:product:select', this.boundHandleProductSelect);
        }
      }

      disconnectedCallback() {
        if (this.scopeElement) {
          this.scopeElement.removeEventListener('shopify:product:select', this.boundHandleProductSelect);
        }
      }

      handleCardClick(event) {
        const card = event.target.closest('.aa-bundle__card');
        if (!card || card.disabled || card.classList.contains('is-selected')) return;

        const optionValueIds = (card.dataset.optionValueIds || '').split(',').filter(Boolean);
        if (!optionValueIds.length) return;

        const scope = this.scopeElement || this.closest('.shopify-section, dialog');
        const picker = scope && scope.querySelector('variant-picker[data-template-product-match="true"]');
        if (!picker) return;

        // Every option fieldset must have its matching radio located before
        // touching the DOM, so a partial match never leaves the picker in a
        // mixed state (some fieldsets updated, others stale).
        const inputs = [];
        for (const optionValueId of optionValueIds) {
          const input = picker.querySelector(`input[data-option-value-id="${optionValueId}"]`);
          if (!input) return;
          inputs.push(input);
        }

        // Optimistic UI: reflect the pick immediately, ahead of the
        // network round-trip that shopify:product:select waits on.
        this.querySelectorAll('.aa-bundle__card').forEach((otherCard) => {
          const isThisCard = otherCard === card;
          otherCard.classList.toggle('is-selected', isThisCard);
          otherCard.setAttribute('aria-pressed', String(isThisCard));
        });

        inputs.forEach((input) => {
          input.checked = true;
        });
        inputs[inputs.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
      }

      async handleProductSelect(event) {
        if (!event || !event.promise) return;

        let result;
        try {
          result = await event.promise;
        } catch (error) {
          return;
        }

        const html = result && result.detail && result.detail.html;
        if (!html) return;

        const blockId = this.dataset.bundleBlockId;
        const newBlock = blockId && html.querySelector(`[data-bundle-block-id="${blockId}"]`);
        if (newBlock) {
          this.replaceWith(newBlock);
        }
      }
    }

    if (!customElements.get('aa-bundle-selector')) {
      customElements.define('aa-bundle-selector', AaBundleSelector);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aa-loyalty-points-strip"] && !Shopify.designMode) return;
  try {
    (() => {
    const findTarget = () => document.querySelector('[data-aa-lp]');

    const sync = (strip) => {
      const target = findTarget();
      const button = strip.querySelector('[data-aa-lps]') || strip;

      if (!target) {
        if (!button.hasAttribute('data-aa-lps-design-mode')) strip.closest('.aa-lps').hidden = true;
        return;
      }

      const source = target.querySelector('[data-aa-lp-earned]');
      const output = button.querySelector('[data-aa-lps-earned]');
      if (!source || !output) return;

      const mirror = () => {
        output.textContent = source.textContent.trim();
      };

      mirror();
      if (!output.dataset.aaLpsObserved) {
        new MutationObserver(mirror).observe(source, { childList: true, characterData: true, subtree: true });
        output.dataset.aaLpsObserved = 'true';
      }
    };

    const init = () => {
      document.querySelectorAll('.aa-lps').forEach(sync);
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-aa-lps]');
      if (!button) return;

      const target = findTarget();
      if (!target) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });

      target.classList.remove('aa-lp--highlight');
      void target.offsetWidth;
      target.classList.add('aa-lp--highlight');
      window.setTimeout(() => target.classList.remove('aa-lp--highlight'), 1600);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aa-loyalty-points"] && !Shopify.designMode) return;
  try {
    (() => {
    const escapeHtml = (value) =>
      String(value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);

    const formatMoney = (cents, format) => {
      const withDelimiters = (amount, decimals, thousands, decimal) => {
        const [whole, fraction] = (amount / 100).toFixed(decimals).split('.');
        const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return fraction ? grouped + decimal + fraction : grouped;
      };

      if (!format) return withDelimiters(cents, 2, ',', '.');

      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount_no_decimals':
            return withDelimiters(cents, 0, ',', '.');
          case 'amount_with_comma_separator':
            return withDelimiters(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return withDelimiters(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return withDelimiters(cents, 2, "'", '.');
          default:
            return withDelimiters(cents, 2, ',', '.');
        }
      });
    };

    const update = (root, variantId) => {
      const configEl = root.querySelector('[data-aa-lp-config]');
      if (!configEl || !variantId) return;

      const config = JSON.parse(configEl.textContent);
      const price = config.prices[String(variantId)];
      if (price === undefined) return;

      const earned = Math.floor((price * config.rate) / 100);
      const next = config.rewards.filter((reward) => reward.points > earned).sort((a, b) => a.points - b.points)[0];
      const unlocked = config.rewards.filter((reward) => reward.points <= earned).sort((a, b) => b.points - a.points)[0];

      const earnedEl = root.querySelector('[data-aa-lp-earned]');
      if (earnedEl) earnedEl.textContent = earned;

      const valueEl = root.querySelector('[data-aa-lp-value]');
      if (valueEl) valueEl.textContent = formatMoney(Math.floor((earned * 100) / config.redeemRate), config.moneyFormat);

      const fill = root.querySelector('[data-aa-lp-fill]');
      if (fill) {
        const progress = next ? Math.min(100, (earned / next.points) * 100) : 100;
        fill.style.setProperty('--aa-lp-progress', `${progress}%`);
        fill.parentElement.setAttribute('aria-valuenow', Math.round(progress));
      }

      const count = root.querySelector('[data-aa-lp-count]');
      if (count) count.textContent = next ? `${earned} / ${next.points} ${config.pointsWord}` : '';

      root.querySelectorAll('[data-aa-lp-stop]').forEach((chip) => {
        const points = Number(chip.dataset.aaLpStop);
        chip.classList.toggle('is-unlocked', points <= earned);
        chip.classList.toggle('is-next', Boolean(next) && points === next.points);
      });

      const nudge = root.querySelector('[data-aa-lp-nudge]');
      if (!nudge) return;

      if (next) {
        nudge.innerHTML = escapeHtml(config.remainingText)
          .replace('[points]', `<strong>${next.points - earned}</strong>`)
          .replace('[reward]', `<strong>${escapeHtml(next.label)}</strong>`);
      } else if (unlocked) {
        nudge.innerHTML = `<strong>${escapeHtml(config.unlockedText.replace('[reward]', unlocked.label))}</strong>`;
      }
    };

    const updateAll = (variantId) => {
      document.querySelectorAll('[data-aa-lp]').forEach((root) => update(root, variantId));
    };

    // Native product forms: the hidden/select "id" field changes with the variant.
    document.addEventListener('change', () => {
      requestAnimationFrame(() => {
        const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (input) updateAll(input.value);
      });
    });

    // Themes that broadcast variant changes as events (Horizon, Dawn pub/sub bridges, etc.).
    document.addEventListener('variant:update', (event) => {
      const variant = event.detail?.resource || event.detail?.variant;
      if (variant?.id) updateAll(variant.id);
    });

    // Animate the progress bar once the card scrolls into view.
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    const observeAll = () => document.querySelectorAll('[data-aa-lp]:not(.is-visible)').forEach((root) => observer.observe(root));
    observeAll();
    document.addEventListener('shopify:block:select', observeAll);
    document.addEventListener('shopify:section:load', observeAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
